import axiosInstance from "../AxiosConfig";

export const fetchAllAgencyMembersApi = async (agencyUuid, params) =>
  axiosInstance.get(`/partners/agency/${agencyUuid}/users`, { params: params });

export const fetchAllAgencyEstimationsApi = async (agency, params) =>
  axiosInstance.get(`/partners/agency/${agency}/users/estimations`, { params: params });

export const exportAgencyUsersApi = async (agencyUuid, usersUuids = []) =>
  axiosInstance.post(`/partners/agency/${agencyUuid}/users/export`, {
    items_id: usersUuids,
  });

export const exportAgencyEstimationsApi = async (networkUuid, estimationsUuids = []) =>
  axiosInstance.post(`/partners/agency/${networkUuid}/users/estimations/export`, {
    items_id: estimationsUuids,
  });

export const fetchAgencyUsersStats = async agencyUuid =>
  axiosInstance.get(`/partners/agency/${agencyUuid}/users/stats`);

export const fetchAgencyEstimationsStats = async (
  agencyUuid,
  validatedOnly = false,
  unarchivedOnly = false,
  startDate,
  endDate,
) =>
  axiosInstance.get(`/partners/agency/${agencyUuid}/users/estimations/stats`, {
    params: {
      ...(startDate && { start_date: startDate }),
      ...(endDate && { end_date: endDate }),
      validated_only: validatedOnly,
      unarchived_only: unarchivedOnly,
    },
  });
